import React from 'react';
import { JUVCard } from '@/components/juv';
import { Syringe } from 'lucide-react';
import TreatmentTable from './TreatmentTable';
import TooltipText from './TooltipText';

const InjectablesSection = () => {
  const neurotoxins = [
    'Xeomin / Dysport – $12/unit',
    'Botox – $14/unit'
  ];

  const fillers = [
    {
      name: 'JUV Mini Pout (Half Syringe)',
      price: '$549'
    },
    {
      name: 'JUV Signature Lip (Full Syringe)',
      price: '$899'
    },
    {
      name: 'JUV Harmony Trio (Nose, Chin, Lips – 3 Syringes)',
      price: '$2,500'
    },
    {
      name: 'JUV Signature Sculpt (3+ Syringes)',
      price: 'From $3,299'
    }
  ];

  return (
    <JUVCard
      title="💉 Injectables"
      icon={Syringe}
      variant="glass"
      className="mb-8"
    >
      <div className="space-y-8">
        {/* Neurotoxins Subsection */}
        <div>
          <h3 className="text-xl font-semibold text-juv-deep-chestnut mb-4">
            Neurotoxins
          </h3>
          <ul className="space-y-2">
            {neurotoxins.map((neurotoxin, index) => (
              <li 
                key={index} 
                className="text-juv-deep-chestnut/80 p-3 bg-juv-soft-blush/30 rounded-lg"
              >
                {index === 1 ? (
                  <TooltipText 
                    text={neurotoxin} 
                    tooltip="Smooths fine lines and prevents wrinkles" 
                  />
                ) : (
                  neurotoxin
                )}
              </li>
            ))}
          </ul>
        </div>

        {/* Dermal Fillers Subsection */}
        <div>
          <h3 className="text-xl font-semibold text-juv-deep-chestnut mb-4">
            Dermal Fillers
          </h3>
          <TreatmentTable
            headers={['Treatment', 'Price']}
            treatments={fillers}
          />
        </div>
      </div>
    </JUVCard>
  );
};

export default InjectablesSection;
